import { useCallback, useRef } from "react";

/** ドラッグ中のDataTransferに、OSやブラウザから渡されたファイルが含まれるか判定する。 */
export function containsDraggedFile(dataTransfer: DataTransfer): boolean {
  if (Array.from(dataTransfer.types).includes("Files")) return true;
  if (Array.from(dataTransfer.items).some((item) => item.kind === "file")) {
    return true;
  }
  return dataTransfer.files.length > 0;
}

/** 閉じたパネルのボタンへファイルが入った時だけ、パネルを一度開く。 */
export function useOpenPanelOnFileDrag(
  isOpen: boolean,
  onOpen: () => void,
): React.DragEventHandler<HTMLButtonElement> {
  const isOpenRef = useRef(isOpen);
  isOpenRef.current = isOpen;

  return useCallback(
    (event: React.DragEvent<HTMLButtonElement>): void => {
      if (isOpenRef.current || !containsDraggedFile(event.dataTransfer)) return;

      event.preventDefault();
      // Reactの再描画前にdragenterが連続しても、onOpenを重複実行しない。
      isOpenRef.current = true;
      onOpen();
    },
    [onOpen],
  );
}
